// import jwtDecode from 'jwtDecode'
const jwtDecode = require('jwt-decode');

import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'
import api from './api'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      alias: ['/login'],
      component: () => import(/* webpackChunkName: "about" */ './views/SignIn.vue')
    },
    {
      path: '/sign-up',
      name: 'sign-up',
      alias: ['/register'],
      component: () => import(/* webpackChunkName: "about" */ './views/SignUp.vue')
    },
    {
      path: '/sign-out',
      name: 'sign-out',
      alias: ['/logout'],
      component: () => import(/* webpackChunkName: "about" */ './views/Logout.vue')
    },
    // {
    //   path: '/guide',
    //   name: 'guide',
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // },
    {
      path: '/faq',
      name: 'faq',
      component: () => import(/* webpackChunkName: "about" */ './views/FAQ.vue')
    },
    {
      path: '/dashboard',
      name: 'user-dashboard',
      component: () => import(/* webpackChunkName: "about" */ './views/Dashboard.vue'),
      meta: { 
        requiresAuth: true
      }      
    },    
    {
      path: '/audit/:auditcode?/:action?',
      name: 'audit',
      component: () => import(/* webpackChunkName: "about" */ './views/Audit.vue'),
      meta: { 
        requiresAuth: true
      }      
    },
    {
      path: '/admin/dashboard',
      name: 'admin-dashboard',
      component: () => import(/* webpackChunkName: "about" */ './views/Admin.vue'),
      meta: { 
        requiresAuth: true,
        isAdmin : true
      }
    }   
  ]
})

// add router guards for guest/authenticated and admin
router.beforeEach((to, from, next) => {
  if (to.name === 'sign-out') {
    delete localStorage.jwt // as JWT is stateless i.e. nothing on server just delete token
    next({ name: 'sign-in', params: { signedout: true } })
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // is user Athenticated
    const isAthenticated = (async () => {
      try {
        const result = await api.post('/authentication', { strategy: 'jwt' })
        store.dispatch('verifyJWT', true)
        store.dispatch('updateUserDetails', jwtDecode(localStorage.getItem('jwt')))
        next()
      } catch (e) {
        store.dispatch('verifyJWT', false)
        next({
            name: 'sign-in',
            params: { nextUrl: to.fullPath }
        })        
      }      
    })() 
  }
  next()

  
  // if (to.matched.some(record => record.meta.requiresAuth)) {
  //   if (localStorage.getItem('jwt') == null) {
  //     next({
  //         path: '/login',
  //         params: { nextUrl: to.fullPath }
  //     })
  //   } else {
  //     let user = jwtDecode(localStorage.getItem('jwt'))
  //     if (to.matched.some(record => record.meta.isAdmin)) {
  //       if (user.isAdmin) {
  //         next()
  //       } else {
  //         next({ name: 'user-dashboard'})
  //       }
  //     }
  //     next()
  //   }
  // } else if (to.matched.some(record => record.meta.guest)) {
  //   if (localStorage.getItem('jwt') == null){
  //     next()
  //   } else {
  //     next({ name: 'user-dashboard'})
  //   }
  // }
  // next() 
})

export default router